export enum DistributeToManager {
  FindingReviewToManagerFindingReview = 1,
  TaggingReviewToManagerTaggingReview,
  FinalReviewToManagerFinalReview,
}
